import PropTypes from "prop-types";
import Button from "../../common/Button";

const SignInOrJoinButton = ({ login, className }) => (
  <Button
    action={login}
    contentKey={"back_in_stock_sign_in_modal_button"}
    className={className}
  />
);

SignInOrJoinButton.propTypes = {
  login: PropTypes.func.isRequired,
  className: PropTypes.string
};

export default SignInOrJoinButton;
